import { State, Effect, dispatch, Actions } from 'jumpstate'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import axios from 'axios'
import {filter, pick} from 'lodash'
import apiAddress from '../utils/APIEndPointAddress'
import persist from '../utils/persist'
import validateNewHorse from '../utils/validateNewHorse'
import {convertYearToJalali} from '../utils/dateHelper'
import qs from 'qs'

const NewHorseState = State({
  initial: {
    details: {
      name: '',
      name_fa: '',
      breeder_id: null,
      breeder: '',
      breeder_fa: '',
      color: { name: '' },
      color_id: null,
      birth_date: parseInt(new Date().getFullYear() - 10, 10),
      birth_date_fa: convertYearToJalali(new Date().getFullYear() - 10),
      gender: 'female',
      sire: {},
      dam: {},
      strain: '',
      sire_id: null,
      dam_id: null,
      death_date: null,
      death_date_fa: null
    },
    photos: [],
    avatar: {},
    errors: {},
    touched: []
  },
  addNewHorsePhoto (state, photo) {
    let photos = [...state.photos, photo]
    persist('newHorse', {photos})
    return {
      ...state,
      photos
    }
  },
  deleteNewHorsePhoto (state, photoId) {
    let photos = filter(state.photos, (item) => {
      return item.photo_id !== photoId
    })
    persist('newHorse', {photos})
    return {
      ...state,
      photos
    }
  },
  setNewHorseAvatar (state, avatar) {
    persist('newHorse', {avatar})
    return {
      ...state,
      avatar
    }
  },
  clearNewHorse (state) {
    window.localStorage.removeItem('newHorse')
    return {
      photos: [],
      avatar: {},
      errors: {},
      details: {
        name: '',
        name_fa: '',
        breeder_id: null,
        breeder: '',
        breeder_fa: '',
        color: {},
        color_id: null,
        birth_date: parseInt(new Date().getFullYear() - 10, 10),
        birth_date_fa: convertYearToJalali(new Date().getFullYear() - 10),
        gender: 'female',
        sire: {},
        dam: {},
        strain: '',
        sire_id: null,
        dam_id: null,
        death_date: null,
        death_date_fa: null
      }
    }
  },
  loadNewHorse (state) {
    return JSON.parse(window.localStorage.getItem('newHorse')) || state.initial
  },
  selectNewHorseAvatar (state, photo) {
    return {
      avatar: photo
    }
  },
  setNewHorseDetails (state, details) {
    return {
      ...state,
      details: {...state.details, ...details}
    }
  },
  addNewHorseTouched (state, field) {
    return {
      ...state,
      touched: [...state.touched, field]
    }
  },
  setAllNewHorseFieldsTouched (state, all = true) {
    const touched = all ? ['name', 'name_fa', 'breeder_id', 'breeder', 'breeder_fa', 'color_id', 'birth_date', 'birth_date_fa', 'gender',
      'sire_id', 'dam_id', 'death_date', 'death_date_fa'] : []
    return {
      ...state,
      touched
    }
  },
  clearNewHorseTouched (state) {
    return {
      ...state,
      touched: []
    }
  },
  validateNewHorseData (state) {
    let values = {...state.details, ...state.avatar, photo_ids: state.photos.map((item) => item.photo_id)}
    delete values.sire
    delete values.dam
    delete values.color
    delete values.staticAvatar
    return {
      ...state,
      errors: validateNewHorse(values)
    }
  }
})

// eslint-disable-next-line
const horseSeekEffect = Effect('horseSeek', (params) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.get(`${apiAddress}horse/auto-complete-${params.gender}?term=${params.keyword}`)
})

// eslint-disable-next-line
const breederSeekEffect = Effect('breederSeek', (keyword) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.get(`${apiAddress}horse/auto-complete-breeder?term=${keyword}`)
})

// eslint-disable-next-line
const colorSeekEffect = Effect('colorSeek', (keyword) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.get(`${apiAddress}horse/auto-complete-color?term=${keyword}`)
})

// eslint-disable-next-line
const saveNewHorseEffect = Effect('saveNewHorse', () => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  const hasErrors = Object.values(NewHorseState.getState().errors).length > 0

  if (hasErrors) { return Promise.reject(new Error('اطلاعات فرم برای ارسال مناسب نیست')) }
  pick(NewHorseState.getState())
  const data = {
    ...pick(NewHorseState.getState().details, ['name', 'name_fa', 'color_id', 'birth_date', 'birth_date_fa', 'breeder',
      'breeder_fa', 'breeder_id', 'gender', 'sire_id', 'dam_id', 'death_date', 'death_date_fa']),
    ...pick(NewHorseState.getState().avatar, ['avatar_id', 'avatar_x', 'avatar_y', 'avatar_w', 'avatar_h']),
    photo_ids: NewHorseState.getState().photos.map((item) => item.photo_id)
  }
  return axios.post(`${apiAddress}horse/new`, qs.stringify(data, {arrayFormat: 'brackets'}))
})

//eslint-disable-next-line
const uploadNewPhotoEffect = Effect('uploadNewPhoto', (params) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })

  var source = axios.CancelToken.source()
  const config = {
    onUploadProgress: params.progress,
    cancelToken: source.token
  }
  params.requestSetter(source)
  return axios.post(`${apiAddress}horse/upload-new-photo`, params.data, config).then((res) => {
    let formData = {}
    for (var pair of params.data.entries()) {
      if (pair[0] !== 'file') {
        formData[pair[0]] = pair[1]
      }
    }
    Actions.addNewHorsePhoto({
      photo_id: res.data.photo_id,
      url: {
        orginal: res.data.photo,
        thumb: res.data.photo_thumb
      },
      ...formData
    })
    return res
  }).catch((err) => {
    if (axios.isCancel(err)) {
      return Promise.reject(Error('آپلود به درخواست شما لغو شد'))
    }
    if (err.response.status === 422 && err.response.data.errors.file !== undefined) {
      return Promise.reject(err.response.data.errors.file[0])
    }
    return Promise.reject(Error('در آپلود مشکلی پیش آمده است، دوباره تلاش کنید.'))
  })
})

export default NewHorseState



// WEBPACK FOOTER //
// ./src/states/newHorse.js